export default {
  install(Vue, options) {
    Vue.mixin({
      created() {
        this.$store.dispatch("setCurrentObject", this);
      },
    });
  },
};
